import React from "react";
import PropTypes from "prop-types";
import { toast, ToastContainer } from "react-toastify";

import LoginService from "../login-service";
import texts from "../../texts/login";
import {
    isValidPhoneNumber,
    isValidPin,
    isValidString,
} from "../../validation/validation";
import HiddenParameters from "../HiddenParameters";
import Input from "../../atoms/Input";
import ButtonWithHelpText2 from "../../atoms/ButtonWithHelpText2";
import { vippsLoginEnabled } from "../../config/config";
import {
    resetPasswordUrl,
    pinTroubleShooterUrl,
    vippsLoginUrl,
} from "../../config/url";
import logo1881 from "../../style/img/1881-logo-screen-secondary-RGB.svg";

class ExistingUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validPhone: true,
            validPin: true,
            validPassword: true,
            userExist: false,
            userHasPasswordLogin: false,
            cellphone: props.cellphone || "",
            submittedPinOrPassword: false,
            submittedLogin: false,
            userHasVippsLogin: false,
            promoSrc: props.promo,
            isPromoImage: null, // null = loading, true = image, false = not an image
        };
    }

    // Async method to check if the URL points to an image by examining the Content-Type header
    async isImageUrl(url) {
        // Validate the URL
        if (!url || typeof url !== "string") {
            console.warn("Invalid URL provided to isImageUrl:", url);
            return false; // Default to non-image if URL is invalid
        }

        try {
            // Use a HEAD request to fetch only the headers
            const response = await fetch(url, { method: "HEAD" });

            if (!response.ok) {
                console.warn(
                    `Failed to fetch URL: ${url}, status: ${response.status}`
                );
                // Fallback to extension-based check
                return (
                    url.toLowerCase().endsWith(".jpg") ||
                    url.toLowerCase().endsWith(".png") ||
                    url.toLowerCase().endsWith(".jpeg")
                );
            }

            // Get the Content-Type header
            const contentType = response.headers
                .get("Content-Type")
                ?.toLowerCase();

            if (!contentType) {
                console.warn(`No Content-Type header found for URL: ${url}`);
                // Fallback to extension-based check
                return (
                    url.toLowerCase().endsWith(".jpg") ||
                    url.toLowerCase().endsWith(".png") ||
                    url.toLowerCase().endsWith(".jpeg")
                );
            }
            console.log(contentType);

            // Check if the Content-Type indicates an image
            return contentType.startsWith("image/");
        } catch (error) {
            console.error(`Error checking Content-Type for URL: ${url}`, error);
            // Fallback to extension-based check
            return (
                url.toLowerCase().endsWith(".jpg") ||
                url.toLowerCase().endsWith(".png") ||
                url.toLowerCase().endsWith(".jpeg")
            );
        }
    }

    // Check the content type of the promo URL when the component mounts or promoSrc changes
    checkPromoContentType() {
        const { promoSrc } = this.state;
        if (promoSrc) {
            this.isImageUrl(promoSrc).then((isImage) => {
                this.setState({ isPromoImage: isImage });
            });
        } else {
            this.setState({ isPromoImage: false }); // No promo, default to false
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
        // Check the content type when the component mounts
        this.checkPromoContentType();

            if (!this.state.promoSrc) {
                const container = document.querySelector('.login-promo-container');
                if (container) {
                    container.classList.add('no-promo');
                }
            }
    }

    componentDidUpdate(prevProps, prevState) {
        // Check the content type if promoSrc changes
        if (prevState.promoSrc !== this.state.promoSrc) {
            this.checkPromoContentType();

            const container = document.querySelector('.login-promo-container');
            if (container) {
                if (!this.state.promoSrc) {
                    container.classList.add('no-promo');
                } else {
                    container.classList.remove('no-promo');
                }
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
    }

    submitGetPinOrPassword(event) {
        event.preventDefault();
        const validPhone = isValidPhoneNumber(this.state.cellphone);
        this.setState({ validPhone, submittedPinOrPassword: true });
        if (validPhone) {
            this.props.submit(this.state.cellphone).then((data) => {
                const userExist = data.userExist;
                const userHasPasswordLogin = data.userHasPasswordLogin;
                const userHasVippsLogin = data.userHasVippsLogin;

                if (userExist) {
                    this.setState({ userExist });
                }

                if (userHasPasswordLogin) {
                    this.setState({ userHasPasswordLogin });
                }

                if (userHasVippsLogin) {
                    this.setState({ userHasVippsLogin });
                }

                if (userExist && !userHasPasswordLogin && !userHasVippsLogin) {
                    LoginService.getPin(this.state.cellphone);
                }
            });
        }
    }

    renderResetPasswordLink() {
        if (this.state.userHasPasswordLogin) {
            return (
                <div>
                    <div className="spacer-bottom-1">
                        <a className="primary" href={resetPasswordUrl}>
                            {texts["existing-user.reset-password"]}
                        </a>
                    </div>
                </div>
            );
        }
    }

    renderDivider() {
        if (
            !this.state.userExist ||
            (this.state.userExist &&
                this.state.userHasPasswordLogin &&
                this.state.userHasVippsLogin)
        ) {
            return <div className="vmp-c-kdWTTr">eller</div>;
        }
    }

    renderRegisterWithVippsLink() {
        if (
            !this.state.userExist ||
            (this.state.userExist && this.state.userHasVippsLogin)
        ) {
            let params = "";
            if (this.props.UserCheckout && this.props.UserCheckout == "true") {
                params = "UserCheckout=" + this.props.UserCheckout;
            }
            if (this.props.SessionCheck && this.props.SessionCheck == "true") {
                params +=
                    (params != "" ? "&" : "") +
                    "SessionCheck=" +
                    this.props.SessionCheck;
            }
            if (this.props.redirectURI) {
                params +=
                    (params != "" ? "&" : "") +
                    "redirectURI=" +
                    this.props.redirectURI;
            }
            if (
                this.props.hashContent &&
                this.props.hashContent !== null &&
                this.props.hashContent !== ""
            ) {
                params +=
                    (params != "" ? "&" : "") +
                    "hashContent=" +
                    this.props.hashContent;
            }

            if (
                this.props.targetApplicationId &&
                this.props.targetApplicationId !== null &&
                this.props.targetApplicationId !== ""
            ) {
                params +=
                    (params != "" ? "&" : "") +
                    "targetApplicationId=" +
                    this.props.targetApplicationId;
            }
            let loginURlWithVipps = vippsLoginUrl;
            if (params !== "") {
                loginURlWithVipps = loginURlWithVipps + "?" + params;
            }
            return (
                <div>
                    <div className="btnVipps">
                        <a
                            href={loginURlWithVipps}
                        >
                            <div className="imSeDo">
                                Fortsett med
                                <img
                                    src={require("../../style/img/small-vipps-logo.svg")}
                                    alt="Vipps Logo"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            );
        }
    }

    renderPinTroubleShooting() {
        if (this.state.userExist) {
            return (
                <div className="center">
                    <div className="spacer-bottom-1">
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className="primary"
                            href={this.getTroubleShooterLink()}
                        >
                            {texts["existing-user.pin-troubleshooter"]}
                        </a>
                    </div>
                </div>
            );
        }
    }

    renderSendingPinAgain() {
        if (this.state.userExist && !this.state.userHasPasswordLogin) {
            return (
                <div>
                    <div className="spacer-bottom-1">
                        <a
                            className="primary"
                            href=""
                            onClick={this.sendPinAgain.bind(this)}
                        >
                            {texts["register-user.pin-send-again"]}
                        </a>
                    </div>
                </div>
            );
        }
    }

    sendPinAgain(event) {
        event.preventDefault();
        return LoginService.getPin(this.state.cellphone).then((result) => {
            if (result === false) {
                toast.error("Send pin mislyktes.");
                this.setState({ pin_error: true });
            } else {
                toast.success("Pin sendt");
                this.setState({ pin_error: false });
            }
        });
    }

    renderSendingPinFailure() {
        if (this.state.pin_error === true) {
            return (
                <div className="spacer-bottom-1">
                    <p
                        className="help-text"
                        style={{ marginTop: "-10px", fontSize: "0.7rem" }}
                        dangerouslySetInnerHTML={{
                            __html: texts["register.pin-send-failure-report"],
                        }}
                    />
                </div>
            );
        }
    }

    getTroubleShooterLink() {
        if (this.state.cellphone) {
            return this.appendRequestParameters(pinTroubleShooterUrl, [
                { key: "cellphone", value: this.state.cellphone },
                { key: "type", value: "pin" },
            ]);
        } else {
            return pinTroubleShooterUrl;
        }
    }

    appendRequestParameters(link, params) {
        return params.reduce((prev, curr, index) => {
            if (index === 0) {
                return `${prev}${encodeURI(curr.key)}=${encodeURI(curr.value)}`;
            } else {
                return `${prev}&${encodeURI(curr.key)}=${encodeURI(
                    curr.value
                )}`;
            }
        }, `${link}?`);
    }

    submitLogin(event) {
        if (!this.state.userHasPasswordLogin) {
            const validPin = isValidPin(this.state.pin);
            if (!validPin) {
                event.preventDefault();
                this.setState({ validPin, submittedLogin: true });
            }
        } else {
            const validPassword = isValidString(this.state.password);
            if (!validPassword) {
                event.preventDefault();
                this.setState({ validPassword, submittedLogin: true });
            }
        }
    }

    phoneChanged(cellphone) {
        cellphone = cellphone.trim();
        const validPhone = isValidPhoneNumber(cellphone);
        this.setState({
            cellphone,
            validPhone,
        });
    }

    pinChanged(pin) {
        this.setState({ pin });
    }

    passwordChanged(password) {
        this.setState({ password });
    }

    renderSubmit() {
        if (this.state.userHasPasswordLogin) {
            return (
                <div>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        label={texts["existing-user.label.password"]}
                        onChange={this.passwordChanged.bind(this)}
                        spacers={1}
                        className="spacer-top-3"
                        autoFocus={true}
                        validationMessage={texts["validation.password"]}
                        isValid={isValidString}
                        submitted={this.state.submittedLogin}
                        autoComplete="current-password"
                    />
                    <button
                        type="submit"
                        disabled={!this.state.validPhone}
                        className="btnSubmit"
                        id="submit"
                    >
                        {texts["existing-user.button.submit"]}
                    </button>
                </div>
            );
        } else {
            if (this.state.userExist) {
                if (this.state.userHasVippsLogin) {
                    {
                        this.renderRegisterWithVippsLink();
                    }
                } else {
                    return (
                        <div>
                            <Input
                                type="text"
                                id="password"
                                name="password"
                                label={texts["existing-user.label.pin"]}
                                onChange={this.pinChanged.bind(this)}
                                spacers={2}
                                className="spacer-top-3"
                                validationMessage={texts["validation.pin"]}
                                isValid={isValidPin}
                                autoComplete="one-time-code"
                                autoFocus={true}
                                submitted={this.state.submittedLogin}
                            />

                            {this.renderSendingPinAgain()}

                            <button
                                type="submit"
                                className="btnSubmit"
                                id="submit"
                            >
                                {texts["existing-user.button.submit"]}
                            </button>
                        </div>
                    );
                }
            } else {
                return (
                    <ButtonWithHelpText2
                        type="submit"
                        text={texts["existing-user.button.getPin"]}
                        helpText={texts["existing-user.help-text"]}
                        id="submit"
                        force_show_info={true}
                    />
                );
            }
        }
    }

    render() {
        return (
            <div className="existing-user">
                <div className="login-container">
                    <div className="login-promo-container">
                        {this.state.promoSrc &&
                            this.state.isPromoImage !== null && (
                                <div className="content-wrapper">
                                    {this.state.isPromoImage ? (
                                        <img
                                            src={this.state.promoSrc}
                                            alt="Promotional Content"
                                            className="promo-image"
                                        />
                                    ) : (
                                        <iframe
                                            src={this.state.promoSrc}
                                            title="Promotional Content"
                                            frameBorder="0"
                                            className="fit-iframe"
                                            scrolling="no"
                                        ></iframe>
                                    )}
                                </div>
                            )}

                        <div className="login-form-wrapper">
                            <img
                                src={logo1881}
                                alt="Opplysningen 1881"
                                className="login-image"
                            />


                            <form
                                action="action"
                                method="post"
                                role="form"
                                noValidate
                                acceptCharset="UTF-8"
                                onSubmit={
                                    this.state.userExist
                                        ? this.submitLogin.bind(this)
                                        : this.submitGetPinOrPassword.bind(this)
                                }
                            >
                                 <h1 className="headline">
                                    Logg inn
                                </h1>



                                <HiddenParameters
                                    CSRFtoken={this.props.CSRFtoken}
                                    redirectURI={this.props.redirectURI}
                                    loginType={
                                        this.state.userHasPasswordLogin
                                            ? "password"
                                            : "pin"
                                    }
                                    hashContent={this.props.hashContent}
                                    UserCheckout={this.props.UserCheckout}
                                    SessionCheck={this.props.SessionCheck}
                                    targetApplicationId={
                                        this.props.targetApplicationId
                                    }
                                />

                                <Input
                                    type="tel"
                                    id="phone-input"
                                    name="user"
                                    label={
                                        texts[
                                            "existing-user.phone-input.placeholder"
                                        ]
                                    }
                                    onChange={this.phoneChanged.bind(this)}
                                    defaultValue={this.props.cellphone.trim()}
                                    spacers={0}
                                    className="spacer-top-4"
                                    validationMessage={
                                        texts["validation.phone"]
                                    }
                                    isValid={isValidPhoneNumber}
                                    autoFocus
                                    submitted={
                                        this.state.submittedPinOrPassword
                                    }
                                    autoComplete="username"

                                />

                                {this.renderSubmit()}
                            </form>

                            {this.renderSendingPinFailure()}
                            {this.renderResetPasswordLink()}

                            {vippsLoginEnabled
                                ? this.renderDivider()
                                : () => {}}
                            {vippsLoginEnabled
                                ? this.renderRegisterWithVippsLink()
                                : () => {}}
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={true}
                />
            </div>
        );
    }

    handleResize() {
        this.forceUpdate();
    }
}

ExistingUser.propTypes = {
    cellphone: PropTypes.string.isRequired,
    CSRFtoken: PropTypes.string.isRequired,
    redirectURI: PropTypes.string.isRequired,
    hashContent: PropTypes.string.isRequired,
    UserCheckout: PropTypes.string.isRequired,
    SessionCheck: PropTypes.string,
    submit: PropTypes.func.isRequired,
    targetApplicationId: PropTypes.string,
    promo: PropTypes.string,
};

ExistingUser.defaultProps = {
    targetApplicationId: "",
    promo: null,
};

export default ExistingUser;
